import { generateUniqueId } from '../../helpers/common';

export const START_OFFLINE_INTERVAL = generateUniqueId();
export const STOP_OFFLINE_INTERVAL = generateUniqueId();
export const SET_HEALTH_DATA = generateUniqueId();
export const SET_INITIAL_HEALTH_DATA = generateUniqueId();
export const SELECT_STATION = generateUniqueId();
export const FILTER_STATUS = generateUniqueId();
export const SET_STATION_ERROR_TYPE = generateUniqueId();

export const FETCH_LATEST_DATA_REQUEST = generateUniqueId();
export const FETCH_LATEST_DATA_SUCCESS = generateUniqueId();
export const FETCH_LATEST_DATA_FAILURE = generateUniqueId();

export const FETCH_ERROR_TYPES_SUCCESS = generateUniqueId();

export const SET_PR_DATA = generateUniqueId();
export const CLEAR_PR_DATA = generateUniqueId();